var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAURLService } from '@ibe.services/url.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
var INDRAAncillaryBlockOfferComponent = /** @class */ (function () {
    function INDRAAncillaryBlockOfferComponent(sanitizer, cdr, ibeAdminService, urlService, currencyService) {
        this.sanitizer = sanitizer;
        this.cdr = cdr;
        this.ibeAdminService = ibeAdminService;
        this.urlService = urlService;
        this.currencyService = currencyService;
        this.INSURANCE = 'INSURANCE';
        this.isLoading = true;
        this.showDescription = false;
    }
    Object.defineProperty(INDRAAncillaryBlockOfferComponent.prototype, "ancillary", {
        set: function (data) {
            this._ancillary = __assign({}, data);
            /* if (!this._ancillary.provider) {
                this._ancillary.provider = Object.assign({}, this._ancillary.provider, {
                    name: 'Booking', logo: 'sprite.svg#partners--booking', label_prefix: '', label_sufix: ''
                });
                this._ancillary = Object.assign({}, this._ancillary, { image: this._ancillary.photo.url_original, title: this._ancillary.hotel_name });
            } */
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Prints title of ancillary
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printTitle = function () {
        if (this._ancillary.type === this.INSURANCE) {
            return this.ibeAdminService.getTranslationValue('bookingDetails.title.insurance');
        }
        return this._ancillary.title;
    };
    /**
     * Prints ancillary description
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printDescription = function () {
        return this._ancillary.description;
    };
    /**
     * Prints ancillary cost
     * Cost converted to environment/market format
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printCost = function () {
        var CAR = 'CAR';
        if (this._ancillary.type === this.INSURANCE || this._ancillary.type == 'tours' || this._ancillary.type == 'nanny' || this._ancillary.type == 'cruise' || this._ancillary.type == 'eSIM') {
            return (this._ancillary.type === this.INSURANCE || this._ancillary.type == 'tours' || this._ancillary.type == 'nanny' || this._ancillary.type == 'cruise' || this._ancillary.type == 'eSIM' ?
                (this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this.ibeAdminService.getTranslationValue('bookingDetails.label.from') + ' ' : '' : '')
                + ((this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this._ancillary.data.price + ' ' + this.currency : '');
        }
        return ((this._ancillary.type === CAR ?
            (this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this.ibeAdminService.getTranslationValue('bookingDetails.label.from') + ' ' : '' : '')
            + ((this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00') ? this._ancillary.data.price + ' ' + this.currency : '')
            +
                (this._ancillary.type == CAR || this._ancillary.type == 'parking' || this._ancillary.type == 'assistance' ?
                    (this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00' ? ' ' + this.ibeAdminService.getTranslationValue('bookingDetails.label.perDay') : '') :
                    this._ancillary.data.price !== 0 && this._ancillary.data.price !== null && this._ancillary.data.price !== '0.00' ? ' ' + this.ibeAdminService.getTranslationValue('bookingDetails.label.perNight') : ''));
    };
    /**
     * Prints ancillary provider prefix
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printProviderPrefix = function () {
        return this._ancillary.label_prefix;
    };
    /**
     * Prints ancillary provider name
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printProvider = function () {
        return this._ancillary.name;
    };
    /**
     * Prints ancillary provider sufix
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printProviderSufix = function () {
        return this._ancillary.label_sufix;
    };
    /**
     * Prints ancillary cta button label
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printButtonLabel = function () {
        return this._ancillary.cta;
    };
    /**
     * Prints ancillary image url
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printImage = function () {
        return this.sanitizer.bypassSecurityTrustStyle("url(" + this._ancillary.image + ")");
    };
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printPartnerLogo = function () {
        return this._ancillary.logo;
    };
    /**
     * Checks if ancillary as stars
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_hasStars = function () {
        return this._ancillary.stars;
    };
    /**
     * Prints all filled or empty stars
     * @param type of stars to print - 'full' | 'empty'
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printStar = function () {
        return this._ancillary.stars;
    };
    /**
     * Prints ancillary type
     */
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printType = function () {
        return this._ancillary.type;
    };
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_hasDiscount = function () {
        return this._ancillary.discount;
    };
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_printDiscount = function () {
        return this._ancillary.discount;
    };
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_ariaLabel = function () {
        var label = '';
        label += this.INDRA_getTextTranslation('bookingDetails.aria.listBookingContacts') + " " + this.INDRA_printType() + ': ';
        label += this.INDRA_printTitle() + ', ';
        label += this.INDRA_printCost() + ', ';
        label += this.INDRA_getTextTranslation('bookingDetails.aria.inPartnershipWith') + this._ancillary.provider + '.';
        if (this.INDRA_hasDiscount()) {
            label += this.INDRA_getTextTranslation('bookingDetails.aria.with') + this.INDRA_printDiscount() + this.INDRA_getTextTranslation('bookingDetails.aria.discount');
        }
        return label;
    };
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_redirectTo = function () {
        var link = this._ancillary.link;
        link = this.urlService.INDRA_updateMaskedField(link, 'LANG_MASK', sessionStorage.getItem('language'));
        link = this.urlService.INDRA_getEscapedUrl(link);
        window.open(link, '_blank' // <- This is what makes it open in a new window.
        );
    };
    INDRAAncillaryBlockOfferComponent.prototype.INDRA_getTextTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAAncillaryBlockOfferComponent.prototype.ngOnInit = function () {
        // setTimeout(() => {
        this.isLoading = false;
        this.cdr.markForCheck();
        // }, 3000);
        this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
    };
    return INDRAAncillaryBlockOfferComponent;
}());
export { INDRAAncillaryBlockOfferComponent };
